import React from 'react';
import { Modal, Panel, Row, Col, Button } from 'rsuite';
import { CountryNewsList } from './CountryNewsList'
import RSSParser from 'rss-parser';
import newsSources from '../utils/newsSources';
import  {CountryGraph} from './CountryGraph' 

export class CountryModal extends React.Component {

    state = {
        news: [],
        maxNumOfNews: 6,
        articlesLoaded: false,
        newsSource: null
    }

    articlesLoaded() {
        this.setState({
            articlesLoaded: true
        })
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.data.country !== prevProps.data.country) {
            const countriesInfo = require('../utils/countries.json');
            this.setState({
                news: [],
                articlesLoaded: false,
                newsSource: null,
                countryFlag: countriesInfo[this.props.data.country] != null ? countriesInfo[this.props.data.country].flag : null 
            })
            const CORS_PROXY = "https://cors-anywhere.herokuapp.com/"

            let countryNewsUrl = "";
            let countrySource = newsSources['Default'];

            if (newsSources[this.props.data.country] != null) {
                countrySource = newsSources[this.props.data.country]
            }

            countryNewsUrl = countrySource.url;

            let parser = new RSSParser();
            parser.parseURL(CORS_PROXY + countryNewsUrl, (err, feed) => {
                if (err) throw err;
                let validItems = 0;
                this.getNewsSource(feed.link)
                feed.items.some((entry) => {
                    if (entry.title.includes('virus') || entry.content.includes('virus') || entry.title.includes('covid') || entry.content.includes('covid')) {
                        validItems++;
                        this.pushRelevantNews(entry);
                    }

                    return validItems === this.state.maxNumOfNews
                })

                this.articlesLoaded()
            })
        }
    }

    pushRelevantNews = (entry) => {
        this.setState(prevState => ({
            news: [...prevState.news, entry]
        }))
    }

    getNewsSource = (source) => {
        this.setState({
            newsSource: source
        })
    }

    close = () => {
        this.props.close();
    }

    Card = props => {
        return (
            <Panel className="country-stat-card" bordered header={props.header}>
                <div style={{ display: 'flex' }}>
                    <div style={{ color: props.color }}>{props.allTimeValue}</div>
                    {props.todayValue !== undefined ? <div style={{ opacity: 0.8, color: props.color, paddingLeft: 5 }}>+{props.todayValue}</div> : null}
                </div>
            </Panel>)
    }

    DonationButton = () => {
        let country = newsSources['Default'];
        if (newsSources[this.props.data.country] != null) {
            country = newsSources[this.props.data.country]
        }
        if (country.donationLink != null) {
            return <Button block style={{ marginTop: 20 }} color="violet" href={country.donationLink}>{country.donationText}</Button>
        }else{
            return null
        }
    }
    

    render() {
        return (
            <Modal onHide={this.close} show={this.props.show}>
                <Modal.Header>
                    <Modal.Title>{this.props.data.country}<span className="country-flag">{this.state.countryFlag}</span> </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row className="country-stats-row">
                        <Col xs={8}>
                            <this.Card allTimeValue={this.props.data.cases} todayValue={this.props.data.todayCases} color={'inherit'} header="Positives"></this.Card>
                        </Col>
                        <Col xs={8}>
                            <this.Card allTimeValue={this.props.data.deaths} todayValue={this.props.data.todayDeaths} color={'#e84118'} header="Deaths"></this.Card>
                        </Col>
                        <Col xs={8}>
                            <this.Card allTimeValue={this.props.data.recovered} color={'#4cd137'} header="Recovered"></this.Card>
                        </Col>
                    </Row>
                    <this.DonationButton />

                    <CountryGraph country={this.props.data.country}/>
                    <CountryNewsList newsSource={this.state.newsSource} articlesLoaded={this.state.articlesLoaded} maxNews={this.state.maxNumOfNews} news={this.state.news} />
                </Modal.Body>
            </Modal>
        )
    }
}